import jmitra from '../jmitra.png';
import konicaMinolta from '../img2.png';
import mylan from '../img3.png';
import gccBiotech from '../img4.jpg';
import carestream from '../img5.png';
import roche from '../img6.jpg';
import prognosys from '../prognosys.png';
import remescan from '../remescan.webp';

export const contact = {
  address: 'GF 1 Ground Floor, Subhash Chandra Bose Complex, Tulsidas Marg, Chowk, Lucknow',
  mapLink: 'https://maps.app.goo.gl/ogT1dBS3kHj1zGhdA',
  phone: '+91 98113 77954',
  phoneLink: 'tel:+919811377954',
  email: 'Snehc.sales@gmail.com',
  emailLink: 'mailto:Snehc.sales@gmail.com',
};

export const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/readMore', label: 'Company' },
  { to: '/about', label: 'Leadership' },
  { to: '/clients', label: 'Clients' },
];

export const products = [
  { icon: 'equipment', title: 'Medical equipment', desc: 'Equipment for hospitals and diagnostic centres.' },
  { icon: 'kit', title: 'Diagnostic kits', desc: 'Kits for hospital laboratories and pathology centres.' },
  { icon: 'radiology', title: 'Radiology equipment', desc: 'Imaging equipment for radiology departments.' },
  { icon: 'blood', title: 'Blood bank', desc: 'Blood bank related products and services.' },
];

export const partners = [
  { name: 'J. Mitra & Co. Pvt. Ltd.', img: jmitra, link: 'https://jmitra.co.in' },
  { name: 'Konica Minolta', img: konicaMinolta, link: 'https://konicaminolta.com' },
  { name: 'Mylan', img: mylan, link: 'https://www.mylan.in/' },
  { name: 'GCC Biotech', img: gccBiotech, link: 'https://gccbiotech.net/' },
  { name: 'Carestream', img: carestream, link: 'https://www.carestream.com/en/us/medical' },
  { name: 'Roche', img: roche, link: 'https://www.roche.com/' },
  { name: 'Prognosys Medical Systems', img: prognosys, link: 'https://www.prognosysmedical.com/' },
  { name: 'Remescan', img: remescan, link: 'https://remescan.in/' },
];

export const stats = [
  { value: '100+', label: 'Clients served' },
  { value: String(partners.length), label: 'Manufacturer partners' },
  { value: '$3.2M', label: 'Average turnover' },
  { value: 'Northern India', label: 'Region served' },
];

export const clientGroups = [
  {
    title: 'Private hospitals',
    clients: [
      { name: 'Charak Hospital', desc: '300-bed multispecialty hospital' },
      { name: 'Midland Hospital', desc: '100-bed multispecialty hospital' },
      { name: 'Globe Hospital', desc: '300-bed multispecialty hospital' },
      { name: 'Apollo Hospital', desc: '500-bed multispecialty hospital' },
      { name: 'Birla Hospital', desc: '300-bed multispecialty hospital' },
    ],
  },
  {
    title: 'Government hospitals',
    clients: [
      { name: 'King George Medical University', desc: 'Established in 1905, with 4,500 functional beds' },
      { name: 'Sanjay Gandhi Post Graduate Institute', desc: 'Established in 1983, spread over 550 acres, with 1,600+ beds' },
      { name: 'SM Medical College, Agra', desc: 'Established in 1854, with 950+ beds' },
      { name: 'GSVM Kanpur Hospital', desc: 'Established in 1956, with 300+ beds' },
    ],
  },
];

export const values = [
  { title: 'Quality', desc: 'Get it right the first time.' },
  { title: 'Reliability', desc: 'Maintain efficiency and discipline in all processes and systems, and fulfil the promises made to stakeholders.' },
  { title: 'Trust', desc: 'Be transparent in dealings.' },
  { title: 'Consistency', desc: 'Endeavour to bring new products to the market and consistently deliver value to stakeholders.' },
];
